<template>
    <div class="modal-window ets006" :class="inOutKbn === false? 'out':'in'">
        <header v-if="tenantId === '201'" class="modal-header">
            <div class="tit">{{$i18nUtil.trans("message.HelpDesk.025","업무공유 시스템 사용 가이드")}}</div>
            <div class="txt" style="padding-left: 28px;">{{$i18nUtil.trans("message.HelpDesk.026","업무공유 시스템의 주요 기능을 확인하세요.")}} </div>
        </header>
        <header v-else class="modal-header">
            <div class="tit">{{$i18nUtil.trans("message.HelpDesk.001","업무공유 시스템/앱 사용 가이드")}}</div>
            <div class="txt">{{$i18nUtil.trans("message.HelpDesk.002","업무공유 시스템 및 앱의 주요 기능과 모바일 앱 설치 방법을 확인하세요.")}} </div>
        </header>
        
        <div class="modal-content" :class="inOutKbn === false ? 'mobile-none-1':''">
            <div class="clear" :class="inOutKbn === false ? 'mobile-none-2':''">
                <ul class="guide-info">
                    <!-- ICT -->
                    <li v-if="tenantId === '418502'">{{$i18nUtil.trans("message.HelpDesk.003","ICT서비스데스크")}} : 02-6313-3114</li>
                    <li v-if="tenantId === '418502'">{{$i18nUtil.trans("message.HelpDesk.004","시스템 담당자")}} : cwadmin@hanwha.com (문의는 메일로 부탁드립니다.)</li>
                    <!-- 한화자산운용 -->
                    <li v-if="tenantId === '432'">{{$i18nUtil.trans("message.HelpDesk.003","ICT서비스데스크")}} : 02-6313-3114</li>
                    <li v-if="tenantId === '432'">{{$i18nUtil.trans("message.HelpDesk.004","시스템 담당자")}} : cwadmin@hanwha.com (문의는 메일로 부탁드립니다.)</li>
                    <!-- 한화투자증권 -->
                    <li v-if="tenantId === '203'">{{$i18nUtil.trans("message.HelpDesk.006","HelpDesk")}} : 02-3772-7788 / {{$i18nUtil.trans("message.HelpDesk.022","내선")}} 7788</li>
                    <li v-if="tenantId === '203'">{{$i18nUtil.trans("message.HelpDesk.004","시스템 담당자")}} : cwadmin@hanwha.com (문의는 메일로 부탁드립니다.)</li>
                    <!-- 한화손해보험 -->
                    <!-- <li v-if="tenantId === '201'">{{$i18nUtil.trans("message.HelpDesk.006","HelpDesk")}} : 02-3772-7788 / {{$i18nUtil.trans("message.HelpDesk.022","내선")}} 7788</li> -->
                    <!-- <li v-if="tenantId === '201' && inOutKbn">{{$i18nUtil.trans("message.HelpDesk.004","시스템 담당자")}} : 02-6313-3904 / {{$i18nUtil.trans("message.HelpDesk.005","이메일")}} : cwhelp4@hanwha.com</li>
                    <li v-if="tenantId === '201' && !inOutKbn">{{$i18nUtil.trans("message.HelpDesk.004","시스템 담당자")}} : 02-6313-3904</li>
                    <li v-if="tenantId === '201' && !inOutKbn">{{$i18nUtil.trans("message.HelpDesk.005","이메일")}} : cwhelp4@hanwha.com</li> -->
                    <br/>
                    <li v-if="tenantId === '201' && !inOutKbn">{{$i18nUtil.trans("message.HelpDesk.004","시스템 담당자")}}</li>
                    <p v-if="tenantId === '201'">&nbsp;- cwadmin@hanwha.com (문의는 메일로 부탁드립니다.)</p>
                    
                </ul>
                <div class="fl" v-if="tenantId === '201'">
                    <!-- 손해보험 분리 -->
                    <ul class="clear">
                        <li v-if="coworkManualList.findIndex(i => i.guideKbn === 'cowork.01') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('cowork.01')">{{$i18nUtil.trans("button.manual.007","홈/공통 유틸 매뉴얼")}}</button>
                        </li>
                        <li v-if="coworkManualList.findIndex(i => i.guideKbn === 'cowork.02') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('cowork.02')">{{$i18nUtil.trans("button.manual.project","과제 공간 매뉴얼")}}</button>
                        </li>                        
                        <li v-if="sharUse === 'true'">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('cowork.03')">{{$i18nUtil.trans("button.manual.009","정보 공유 매뉴얼")}}</button>
                        </li>
                        <li v-if="coworkManualList.findIndex(i => i.guideKbn === 'cowork.04') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('cowork.04')">{{$i18nUtil.trans("button.manual.008","통합검색 매뉴얼")}}</button>
                        </li>
                    </ul>
                    <ul class="clear" v-if="tenantId !== '418502'">
                        <li v-if="okrManualList.findIndex(i => i.guideKbn === 'okr.01') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('okr.01')">{{$i18nUtil.trans("button.manual.004","개인 매뉴얼")}}</button>
                        </li>
                        <li v-if="okrManualList.findIndex(i => i.guideKbn === 'okr.02') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('okr.02')">{{$i18nUtil.trans("button.manual.002","팀장 매뉴얼")}}</button>
                        </li>
                        <li v-if="okrManualList.findIndex(i => i.guideKbn === 'okr.03') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('okr.03')">{{$i18nUtil.trans("button.manual.001","본부/실장 매뉴얼")}}</button>
                        </li>
                    </ul>
                    <h2 :class="inOutKbn === false ? 'none':''">{{$i18nUtil.trans("message.HelpDesk.010","모바일 사용자")}}</h2>
                    <div class="nodata" :class="inOutKbn === false ? 'none':''" v-if="mobileServiceUse === false">
                        <p>{{$i18nUtil.trans("message.HelpDesk.021","준비 중 입니다")}}</p>
                    </div>
                    <div class="tit" :class="inOutKbn === false ? 'none':''" v-if="mobileServiceUse === true">{{$i18nUtil.trans("message.HelpDesk.011","모바일 협업/정보공유/회의협의/OKR 사용가이드")}}</div>
                    <ul class="clear" :class="inOutKbn === false ? 'none':''" v-if="mobileServiceUse === true">
                        <li>
                            <button type="button" class="btn-primary-small" v-show="mobileManualList.findIndex(i => i.guideKbn === 'mobile.01') > -1" @click="downLoadManual('mobile.01')">{{$i18nUtil.trans("message.HelpDesk.012","모바일 매뉴얼")}}</button>
                        </li>
                    </ul>
                </div>
                <div class="fl" v-else>
                    <h2>{{$i18nUtil.trans("message.HelpDesk.007","PC 사용자")}}</h2>
                    <div class="tit" v-if="tenantId !== '418502'">{{$i18nUtil.trans("message.HelpDesk.008","OKR 성과 관리 사용자 가이드")}}</div>
                    <ul class="clear" v-if="tenantId !== '418502'">
                        <li v-if="okrManualList.findIndex(i => i.guideKbn === 'okr.01') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('okr.01')">{{$i18nUtil.trans("button.manual.001","본부/실장 매뉴얼")}}</button>
                        </li>
                        <li v-if="okrManualList.findIndex(i => i.guideKbn === 'okr.02') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('okr.02')">{{$i18nUtil.trans("button.manual.002","팀장 매뉴얼")}}</button>
                        </li>
                        <li v-if="
                        (okrManualList.findIndex(i => i.guideKbn === 'okr.03') > -1 && tenantId != '432') &&
                        (okrManualList.findIndex(i => i.guideKbn === 'okr.03') > -1 && tenantId != '203')
                        ">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('okr.03')">{{$i18nUtil.trans("button.manual.003","파트장/캡틴 매뉴얼")}}</button>
                        </li>
                        <li v-if="okrManualList.findIndex(i => i.guideKbn === 'okr.04') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('okr.04')">{{$i18nUtil.trans("button.manual.004","개인 매뉴얼")}}</button>
                        </li>
                    </ul>
                    <!-- <div class="tit">협업/정보공유/회의협의 사용자 가이드 </div> -->
                    <div class="tit" v-if="tenantId !== '201'">{{$i18nUtil.trans("message.HelpDesk.009","협업 사용자 가이드")}}</div>
                    <ul class="clear">
                        <li v-if="coworkManualList.findIndex(i => i.guideKbn === 'cowork.01') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('cowork.01')">{{$i18nUtil.trans("button.manual.project","과제 공간 매뉴얼")}}</button>
                        </li>                        
                        <li v-if="coworkManualList.findIndex(i => i.guideKbn === 'cowork.04') > -1" >
                            <button type="button" class="btn-primary-small" @click="downLoadManual('cowork.04')">{{$i18nUtil.trans("button.manual.006","나의 공간 매뉴얼")}}</button>
                        </li>
                        <li v-if="coworkManualList.findIndex(i => i.guideKbn === 'cowork.05') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('cowork.05')">{{$i18nUtil.trans("button.manual.007","홈/공통 유틸 매뉴얼")}}</button>
                        </li>
                        <li v-if="coworkManualList.findIndex(i => i.guideKbn === 'cowork.06') > -1">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('cowork.06')">{{$i18nUtil.trans("button.manual.008","통합검색 매뉴얼")}}</button>
                        </li>
                        <li v-if="sharUse === 'true'">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('cowork.02')">{{$i18nUtil.trans("button.manual.009","정보 공유 매뉴얼")}}</button>
                        </li>
                        <li v-if="cfrcUse === 'true'">
                            <button type="button" class="btn-primary-small" @click="downLoadManual('cowork.03')">{{$i18nUtil.trans("button.manual.010","회의 협의 매뉴얼")}}</button>
                        </li>
                    </ul>
                    <h2 :class="inOutKbn === false ? 'none':''">{{$i18nUtil.trans("message.HelpDesk.010","모바일 사용자")}}</h2>
                    <div class="nodata" :class="inOutKbn === false ? 'none':''" v-if="mobileServiceUse === false">
                        <p>{{$i18nUtil.trans("message.HelpDesk.021","준비 중 입니다")}}</p>
                    </div>
                    <div class="tit" :class="inOutKbn === false ? 'none':''" v-if="mobileServiceUse === true">{{$i18nUtil.trans("message.HelpDesk.011","모바일 협업/정보공유/회의협의/OKR 사용가이드")}}</div>
                    <ul class="clear" :class="inOutKbn === false ? 'none':''" v-if="mobileServiceUse === true">
                        <li>
                            <button type="button" class="btn-primary-small" v-show="mobileManualList.findIndex(i => i.guideKbn === 'mobile.01') > -1" @click="downLoadManual('mobile.01')">{{$i18nUtil.trans("message.HelpDesk.012","모바일 매뉴얼")}}</button>
                        </li>
                    </ul>
                </div>
                <div class="fr" :class="inOutKbn === false ? 'none':''" v-if="mobileServiceUse === true">
                    <h2>{{$i18nUtil.trans("message.HelpDesk.013","업무공유 앱 설치방법")}}</h2>
                    <div class="tit">{{$i18nUtil.trans("message.HelpDesk.014","1. 설치 주소 직접 접속")}}</div>
                    <div class="txt">{{$i18nUtil.trans("message.HelpDesk.015","모바일 웹 브라우저에 아래 URL을 입력하시거나 QR 코드를 스캔하여 접속 하세요.")}}</div>
                    <div class="reader">
                        <!-- ICT & 방산 -->
                        <ul class="clear" v-if="tenantId === '418502'">
                            <li>
                                <div class="txt">1) 모바일 웹 브라우저 아래 URL 입력</div>
                                <input type="url" v-if="host.indexOf('localhost') > -1" value="http://defdev.cp.hanwha.com/appstore" readonly>
                                <input type="url" v-else-if="host.indexOf('defdev') > -1" value="http://defdev.cp.hanwha.com/appstore" readonly>
                                <input type="url" v-else-if="host.indexOf('defstg') > -1" value="http://defstg.cp.hanwha.com/appstore" readonly>
                                <input type="url" v-else value="https://def.cp.hanwha.com/appstore" readonly>
                            </li>
                            <li>
                                <div class="txt">2) QR 코드 리더기로 스캔</div>
                                <div class="qr">
                                    <img v-if="host.indexOf('localhost') > -1" src="@/assets/img/qrCode/qrCode_HONE_DEV.png">
                                    <img v-else-if="host.indexOf('defdev') > -1" src="@/assets/img/qrCode/qrCode_HONE_DEV.png">
                                    <img v-else-if="host.indexOf('defstg') > -1" src="@/assets/img/qrCode/qrCode_HONE_STG.png">
                                    <img v-else src="@/assets/img/qrCode/qrCode_HONE_PRD.png">
                                </div>
                            </li>
                        </ul>
                        <!-- 금융사 -->
                        <ul class="clear" v-else>
                            <li>
                                <div class="txt">{{$i18nUtil.trans("message.HelpDesk.016","1) 모바일 웹 브라우저 아래 URL 입력")}}</div>
                                <input type="url" v-if="host.indexOf('localhost') > -1" value="http://cpdev.hanwha.com/appstore" readonly>
                                <input type="url" v-else-if="host.indexOf('cpdev') > -1" value="http://cpdev.hanwha.com/appstore" readonly>
                                <input type="url" v-else-if="host.indexOf('cpstg') > -1" value="http://cpstg.hanwha.com/appstore" readonly>
                                <input type="url" v-else value="https://cp.hanwha.com/appstore" readonly>
                            </li>
                            <li>
                                <div class="txt">{{$i18nUtil.trans("message.HelpDesk.017","2) QR 코드 리더기로 스캔")}}</div>
                                <div class="qr">
                                    <img v-if="host.indexOf('localhost') > -1" src="@/assets/img/qrCode/qrCode_DEV.png">
                                    <img v-else-if="host.indexOf('cpdev') > -1" src="@/assets/img/qrCode/qrCode_DEV.png">
                                    <img v-else-if="host.indexOf('cpstg') > -1" src="@/assets/img/qrCode/qrCode_STG.png">
                                    <img v-else src="@/assets/img/qrCode/qrCode_NBP_PRD.png">
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="tit">{{$i18nUtil.trans("message.HelpDesk.018","2. SMS로 설치 경로 받기")}}</div>
                    <div class="txt">{{$i18nUtil.trans("message.HelpDesk.019","전송 버튼을 클릭하여 문자메시지로 설치경로를 받으세요.")}}</div>
                    <div class="phone">
                        <input type="text" v-model="cellPhoneNo" readonly style="width : 30%;">
                        <button type="button" class="btn-primary-small black" @click="sendSMS">{{$i18nUtil.trans("button.send","전송")}}</button>
                    </div>
                    <div class="ref">{{$i18nUtil.trans("message.HelpDesk.020","* 위 번호가 맞지 않을 경우, 서클 개인정보에서 모바일 번호를 수정하세요.")}}</div>
                </div>
                <div class="fr" :class="inOutKbn === false ? 'none':''" v-else>
                    <h2>{{$i18nUtil.trans("message.HelpDesk.013","업무공유 앱 설치방법")}}</h2>
                    <div class="nodata">
                        <p>{{$i18nUtil.trans("message.HelpDesk.021","준비 중 입니다")}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
    components: {
    },
    data() {
        return {
            host : "",
            cellPhoneNo : "",
            mobileServiceUse : false,
            guideKbnList: [
                "cowork.01", "cowork.02", 
                "cowork.03", "cowork.04", 
                "cowork.05", "cowork.06", 
                "mobile.01", "okr.01", 
                "okr.02", "okr.03", "okr.04"
            ],
            okrManualList : [],
            coworkManualList : [],
            mobileManualList : [],
            sharUse: localStorage.getItem("sharUse"),
            cfrcUse: localStorage.getItem("cfrcUse"),
            tenantId: localStorage.getItem("tenantId"),
            userId: localStorage.getItem("userId"),
            inOutKbn: localStorage.getItem("isExternalServiceUse") == "true" ? true : false
        };
    },
    mounted() {
        this.getHostInfo();
        /* 가이드 파일 목록 조회 */
        this.getHelpDeskFileList();
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("modals", ["showDialog", "showModal"]),
        getHostInfo() {
            let obj = this;
            let reqData = {
                url: "/api/auth/getHelpDeskUserInfo",
                method: "post",
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.result !== null) {
                    obj.host = res.result.host;
                    obj.cellPhoneNo = res.result.cellPhoneNo;
                    obj.mobileServiceUse = res.result.mobileServiceUse;
                }
            })
            .catch(function(err) {
                console.log(err);
            })
        },
        /* 가이드 파일 목록 조회 */
        getHelpDeskFileList() {
            let obj = this;
            let reqData = {
                url: "/api/cofile/cofile/getManualList",
                method: "post",
                params : {
                    guideKbnList : obj.guideKbnList
                }
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.errorCode !== null) {
                    let errorCode = res.errorCode;
                } else {
                    if(res.result !== null) {
                        if(res.result.mobileManualList !== null) {
                            obj.mobileManualList = res.result.mobileManualList;
                        }
                        if(res.result.okrManualList !== null) {
                            obj.okrManualList = res.result.okrManualList;
                        }
                        if(res.result.coworkManualList !== null) {
                            obj.coworkManualList = res.result.coworkManualList;
                        }
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            })
        },
        downLoadManual(manualType) {
            let obj = this;
            let fileId = null;
            let fileName = null;
            if(manualType.indexOf('okr') > -1) {
                obj.okrManualList.findIndex((item, index, array) => {
                    if(manualType === item.guideKbn) {
                        fileId = item.fileId;
                        fileName = item.fileName;
                    }
                })
            } else if(manualType.indexOf('cowork') > -1) {
                obj.coworkManualList.findIndex((item, index, array) => {
                    if(manualType === item.guideKbn) {
                        fileId = item.fileId;
                        fileName = item.fileName;
                    }
                })
            } else {
                obj.mobileManualList.findIndex((item, index, array) => {
                    if(manualType === item.guideKbn) {
                        fileId = item.fileId;
                        fileName = item.fileName;
                    }
                })
            }
            let param = {fileId : fileId}
            obj.$axios({
                url: "/api/cofile/cofile/downloadManual",
                responseType: "blob",
                headers: {
                    "Content-Type": "application/json"
                },
                method: "post",
                data: param
            })
            .then(function(res) {
                try {
                    let blob = new Blob([res.data], {
                        type: res.headers["content-type"]
                    });
                    
                    if(res.data.type.startsWith("application/json")) {
                        let errorCode = obj.blobToString(blob);
                        if(errorCode == "COFILE_FILE_DOWNLOAD_FAIL") {
                            let info = {
                                title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
                                contents: obj.$i18nUtil.trans("AB077"),
                                button: obj.$i18nUtil.trans("button.dialog.confirm","확인"),
                            }
                            obj.handleDialog(info);
                            return;
                        }
                    }
                    
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        let link = document.createElement("a");
                        link.target = "_self";
                        link.setAttribute("download", fileName);
                        link.href = window.URL.createObjectURL(blob);
                        link.click();
                        link.remove();
                    }
                } catch (e) {
                    let info = {
                        title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
                        contents: obj.$i18nUtil.trans("AB077"),
                        button: obj.$i18nUtil.trans("button.dialog.confirm","확인"),
                    }
                    obj.handleDialog(info);
                    console.error(e);
                }
            })
            .catch(function(err) {
                let info = {
                    title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
                    contents: obj.$i18nUtil.trans("AB077"),
                    button: obj.$i18nUtil.trans("button.dialog.confirm","확인"),
                }
                obj.handleDialog(info);
                console.log(err);
            })
        },
        sendSMS() {
            let obj = this;
            let reqData = {
                url: "/api/auth/sendSMSOfHelpDesk",
                method: "post",
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.errorCode !== null) {
                    console.log(res.errorCode);
                } else {
                    if(res.result !== null) {
                        console.log(res.result);
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            })
        },
        handleDialog(info) {
            const dialogInfo = {
                obj: this.$modal,
                component: Dialog,
                title : info.title,
                button : info.button,
                contents : info.contents
            };
            this.showDialog(dialogInfo);
        },
        /* blob To string */
        blobToString(blob) {
            let u, x;
            u = URL.createObjectURL(blob);
            x = new XMLHttpRequest();
            x.open('GET', u, false);
            x.send();
            URL.revokeObjectURL(u);
            return x.responseText;
        },
    },
}
</script>
<style scoped>
.mobile-none-1 {
    text-align:center;
}
.mobile-none-2{
    text-align: initial;
    display: inline-block;
}
.none {
    display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/common/helpDesk/HelpDesk.vue